<template>
  <div class="pageWrap">
    <!-- 导航栏 -->
    <navi-header :isScroll="isScroll"></navi-header>

    <div class="videoWrap">
      <div v-for="(item, index) in videoList" class="videoBox" :key="index">
        <a :href="item.url" target="_blank">
          <div
            class="faceIMgBox"
            :style="{ backgroundImage: 'url(' + item.cover + ')' }"
          ></div>
          <div class="title dian">
            <img v-if="item.type === 'VIDEO'" src="../assets/images/video.png" style="width: 0.18rem;flex-shrink: 0;margin-right: 0.05rem;" alt="">
            <span class="dian">{{ item.title }}</span>
          </div>
          <div class="info flexClass">
            <div class="time">{{ item.publishDate }}</div>
            <div class="num flexCenter">
              <img class="boIcon" src="../assets/images/icon_bo2.png" alt="" />
              {{ item.browseCount }}
            </div>
          </div>
        </a>
      </div>
    </div>

    <div class="paginBox" style="text-align: center;padding: 0.3rem 0;">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="size"
        :total="total"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import naviHeader from "@/components/naviHeader.vue";
export default {
  name: "Videolist",
  data() {
    return {
      isScroll: false,
      page: 1,
      size: 15,
      total: 0,
      videoList: [
        {
          id: "1",
          title: "无忧无虑的时刻，当然要拍照记录啦",
          url: "https://www.tvcbook.com/video/1207757.html",
          playnum: "40902",
          time: "2023年11月29日",
          img: "https://growthideadata.oss-cn-beijing.aliyuncs.com/zy/video/cover/1.png",
        },
      ],
    };
  },

  components: {
    naviHeader,
  },

  mounted() {
    window.addEventListener("scroll", this.handleScroll, true); // 监听（绑定）滚轮滚动事件

    this.getVideoListFun();
  },

  methods: {
    handleScroll(e) {
      // console.log("滚动距离",e);
      // let scrollTop = e.target.scrollTop;
      // console.log("scrollTop:",scrollTop);

      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // console.log("scrollTop:",scrollTop);
      if (scrollTop > 5) {
        this.isScroll = true;
      } else {
        this.isScroll = false;
      }
    },

    handleCurrentChange(e){
        // console.log("e",e)
        this.page = e;
        this.getVideoListFun();
    },

    //获取案例信息
    getVideoListFun() {
      let dataObj = {
        page: this.page,
        size: this.size,
      };
      this.getDataInfo("post2", "/business/achievement/page", dataObj).then(
        (res) => {
        //   console.log("获取作品列表", res);
          if (res.data.code == 200) {
            let list = res.data.data.page.records;
            this.videoList = list;
            this.total = res.data.data.page.total;
          }
        }
      );
    },
  },
};
</script>

<style scoped>
.pageWrap {
  background-color: rgba(0, 0, 0, 1);
  margin: 0;
  color: #fff;
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

.videoWrap {
  padding: 0 0.6rem;
  padding-top: 1rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.videoBox {
  width: 3.34rem;
  /* height: 2.52rem; */
  background-color: #1f1f28;
  border-radius: 0.12rem;
  overflow: hidden;
  margin: 0 0.1rem 0.2rem;
}
.videoBox:hover {
  box-shadow: 0 9px 24px 2px rgba(255, 255, 255, 0.2);
}
.faceImg {
  width: 100%;
  /* height: 100%; */
  display: block;
}

.faceIMgBox {
  width: 100%;
  height: 1.86rem;
  overflow: hidden;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: 100% auto;
}

.title {
  font-size: 0.16rem;
  padding: 0.1rem 0.2rem;
  height: 0.4rem;
  display: flex;
  align-items: center;
  /* background-color: green; */
}

.info {
  font-size: 0.12rem;
  padding: 0 0.2rem 0.14rem;
  color: rgba(255, 255, 255, 0.7);
}

.boIcon {
  width: 0.2rem;
  /* height: 0.1rem; */
  flex-shrink: 0;
  margin-right: 0.05rem;
}

.paginBox >>> .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1f1f28;
    color: #FFF;
}
.paginBox >>> .el-pagination.is-background .el-pager li {
    color: #606266;
}


</style>


// WEBPACK FOOTER //
// src/pages/videoList.vue